import { Center, useTheme } from "@chakra-ui/react";
import { Loader } from "lucide-react";

const LoadingComponent = ({
  height = "800px",
  size,
}: {
  height?: string;
  size?: string;
}) => {
  const theme = useTheme();
  return (
    <Center
      width={"100%"}
      height={height}
      zIndex={"overlay"}
      backdropFilter={"auto"}
      backdropBlur={"5px"}
    >
      <Loader
        size={size}
        className="spinning"
        color={theme.colors.brand.primary.DEFAULT}
      />
    </Center>
  );
};

export default LoadingComponent;
